<template>
  <div class="blockscan-page">
    <el-row class="blockscan-page__row">
      <p class="page-form-title">Block Scan Page</p>
      <p class="page-form-tip">The Blockchain Explorer.</p>
      <el-input
        :placeholder="placeholder"
        v-model="input"
        class="input-with-select"
      >
        <el-select v-model="select" slot="prepend" class="input-select">
          <el-option label="Block" value="block"></el-option>
          <el-option label="Transaction" value="transaction"></el-option>
        </el-select>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="onSearch"
        ></el-button>
      </el-input>
    </el-row>
    <el-row class="blockscan-page__row">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
        <p class="blockscan-page__title">Latest Blocks</p>
        <p class="page-form-tip" v-if="totalBlocks">
          <i class="el-icon-info"></i>Total of {{ totalBlocks }} blocks.
        </p>
        <el-table
          :data="blocks"
          stripe
          border
          style="width: 100%"
          v-loading="isBlocksLoading"
          height="300"
          :cell-style="cellStyle"
          @cell-click="cellClick"
        >
          <el-table-column prop="height" label="Block">
            <template slot-scope="scope">
              <el-tag type="primary" effect="dark" disable-transitions
                ><i class="el-icon-s-data"></i> {{ scope.row.height }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="transaction_count" label="Transaction Count">
            <template slot-scope="scope">
              <el-tag type="primary" disable-transitions
                ><i class="el-icon-document-copy"></i> {{ scope.row.transaction_count }}
                {{
                  scope.row.transaction_count > 1
                    ? 'Transactions'
                    : 'Transaction'
                }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="created_time"
            label="Time"
            :formatter="dateFilters"
          >
          </el-table-column>
        </el-table>
        <div class="is-more" @click="onSearchBlocks">
          View all blocks<i class="el-icon-arrow-right"></i>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
        <p class="blockscan-page__title">Latest Transactions</p>
        <p class="page-form-tip" v-if="totalTransactions">
          <i class="el-icon-info"></i>Total of
          {{ totalTransactions }} transactions.
        </p>
        <el-table
          :data="transactions"
          stripe
          border
          style="width: 100%"
          v-loading="isTxsLoading"
          height="300"
          :cell-style="cellStyle"
          @cell-click="cellClick"
        >
          <el-table-column prop="txid" label="Txid" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="block_height" label="Block">
            <template slot-scope="scope">
              <el-tag type="primary" effect="dark" disable-transitions
                ><i class="el-icon-s-data"></i> {{ scope.row.block_height }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="creator_id" label="Creator">
            <template slot-scope="scope">
              {{ scope.row.creator_id ? scope.row.creator_id.match(/(\S*)@/)[1] : 'Initial block' }}
            </template>
          </el-table-column>
          <el-table-column prop="time" label="Time" :formatter="dateFilters">
          </el-table-column>
        </el-table>
        <div class="is-more" @click="onSearchTransactions">
          View all transactions<i class="el-icon-arrow-right"></i>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import format from 'date-fns/format'

export default {
  name: 'block-scan-page',

  data() {
    return {
      blocks: undefined,
      transactions: undefined,
      isBlocksLoading: true,
      isTxsLoading: true,
      select: 'block',
      input: '',
      totalBlocks: undefined,
      totalTransactions: undefined
    }
  },

  computed: {
    placeholder() {
      return this.select === 'block'
        ? 'Search by Block Height'
        : 'Search by Transaction Hash'
    }
  },

  methods: {
    onSearch() {
      if (!this.input) return

      if (this.select === 'block') {
        this.onSearchBlock(this.input)
      } else {
        this.onSearchTransaction(this.input)
      }
    },
    onSearchBlock(block) {
      if (!block || !/^[1-9]\d*$/.test(block)) {
        this.$message.error(
          'The block height must be a positive integer greater than 0'
        )
        return
      }
      this.$router.push({
        name: 'block-page',
        query: { height: block }
      })
    },
    onSearchTransaction(tx) {
      this.$router.push({
        name: 'transaction-page',
        query: { tx_hashes: tx }
      })
    },
    onSearchBlocks() {
      this.$router.push({
        name: 'blocks-page'
      })
    },
    onSearchTransactions() {
      this.$router.push({
        name: 'transactions-page'
      })
    },
    getBlocks() {
      this.$axios({
        method: 'get',
        url: '/api/blocks',
        params: {
          page: 1,
          per_page: 10
        }
      })
        .then((response) => {
          this.blocks = response.data
          this.totalBlocks = response.headers['x-total']
          this.isBlocksLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isBlocksLoading = false
        })
    },
    getTransactions() {
      this.$axios({
        method: 'get',
        url: '/api/transactions',
        params: {
          page: 1,
          per_page: 10
        }
      })
        .then((response) => {
          this.transactions = response.data
          this.totalTransactions = response.headers['x-total']
          this.isTxsLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isTxsLoading = false
        })
    },
    dateFilters(row, column) {
      const date = row.created_time || row.time
      return date
        ? format(date * 1000, 'MMMM d, yyyy HH:mm:ss')
        : 'Initial block'
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      switch (column.property) {
        case 'txid':
          return 'font-weight: 700; cursor: pointer;'
        case 'block_height':
          return 'cursor: pointer;'
        case 'height':
          return 'cursor: pointer;'
        case 'transaction_count':
          return 'cursor: pointer;'

        default:
          break
      }
    },
    cellClick(row, column, cell, event) {
      switch (column.property) {
        case 'block_height':
          this.onSearchBlock(row.block_height)
          break

        case 'height':
          this.onSearchBlock(row.height)
          break

        case 'txid':
          this.onSearchTransaction(row.txid)
          break

        case 'transaction_count':
          this.$router.push({
            name: 'transactions-page',
            query: {
              height: row.height
            }
          })
          break

        default:
          break
      }
    }
  },

  created() {
    this.getBlocks()
    this.getTransactions()
  }
}
</script>

<style scoped lang="scss">
.blockscan-page {
  &__row {
    padding: 2rem;
    &:nth-child(2) {
      padding-top: 0;
    }
  }
  &__title {
    margin: 2rem 0 0.5rem 0;
    display: block;
    font-weight: bold;
  }
}
.is-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #fafafa;
  color: #333;
  font-size: 0.75rem;
  padding: 5px 0;
  border: 1px solid #ebeef5;
  border-top: none;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
}
.input-with-select {
  .input-select {
    width: 150px;
  }
}
</style>
